import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dropdown-button',
    templateUrl: './dropdown-button.component.html',
    styleUrls: ['./dropdown-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DropdownButtonComponent {

    @Input({ required: true }) text!: string;

    constructor() {
    }
}
